// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import find from 'lodash/find'
import React from 'react'
import { i18n } from '../../index'
import css from './EmployeeAdditionalInfo.css'
import type { StaffMember } from './types'
// import type {ActivityDescription} from '../../activityDescription/activityDescriptionTypes'
import InfoIcon from '@mui/icons-material/Info'
import { Trans } from 'react-i18next'
import { Station } from '../../station/stationTypes'

type ActivityDescription = {
  id: string
  name: string
  description: string
  station: Station
}

type Props = {
  employee: StaffMember
  activityDescriptions: Array<ActivityDescription>
}

type State = {
  isDialogOpen: boolean
  employeeAdditionalInfoDialogContent: string
}

class EmployeeAdditionalInfo extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      isDialogOpen: false,
      employeeAdditionalInfoDialogContent: '',
    }
  }

  openDialog = (e: Event, activityDescriptionTxt: string) => {
    this.setState({
      isDialogOpen: true,
      employeeAdditionalInfoDialogContent: activityDescriptionTxt,
    })
  }
  closeDialog = () => {
    this.setState({
      isDialogOpen: false,
      employeeAdditionalInfoDialogContent: '',
    })
  }

  render() {
    const { employee, activityDescriptions, reservationsCount, date } = this.props
    const { isDialogOpen, employeeAdditionalInfoDialogContent } = this.state
    const defaultActivityDescription = `${i18n.t('common.morningShift')}:

${i18n.t('common.eveningShift')}:

${i18n.t('common.nightShift')}:`
    return (
      <div className={css.wrapper}>
        <div className={css.twoColumns}>
          <div className={css.leftColumn}>
            <div className={css.row}>
              <div className={css.rowLabel}>
                <b>{i18n.t('staffingPlan.position')}</b>:{' '}
              </div>
              <div className={css.rowContent}>
                {[...new Set(employee.employeeCardAdditional.activities)].map((a, i) => {
                  const activityDescription = find(activityDescriptions, (d) => d.name === a)
                  const activityDescriptionTxt = activityDescription
                    ? activityDescription.description
                    : defaultActivityDescription
                  return (
                    <span
                      key={i}
                      className={css.activityItem}
                      onClick={(e) => this.openDialog(e, activityDescriptionTxt)}
                    >
                      {i18n.t(`staffingPlan.positions.${a}`)}
                      <div className={css.infoIconWrapper}>
                        <InfoIcon className={css.actionIcon} />
                      </div>
                    </span>
                  )
                })}
              </div>
            </div>
            <div className={css.row}>
              <div className={css.rowLabel}>
                <b>{i18n.t('staffingPlan.responsibility')}</b>:{' '}
              </div>
              <div className={css.rowContent}>
                {[...new Set(employee.employeeCardAdditional.responsibilities)].join(', ')}
              </div>
            </div>
          </div>
          <div className={css.rightColumn}>
            {employee.employeeCardAdditional.hasActiveTask && (
              <div className={css.hasActiveTask}>
                <Trans
                  i18nKey='employeeCard.hasActiveTask'
                  components={{ lnk: <a href='/tehtavalista' />, bold: <b /> }}
                />
              </div>
            )}
            {reservationsCount > 0 && (
              <div className={css.hasActiveTask}>
                <Trans
                  i18nKey='employeeCard.reservationsToday'
                  values={{ reservationsCount }}
                  components={{ lnk: <a href={`/ravintolainfo/${date}`} />, bold: <b /> }}
                />
              </div>
            )}
          </div>
        </div>
        <Dialog open={isDialogOpen} onClose={this.closeDialog} maxWidth='md' className={css.employeeDialog}>
          <DialogTitle className={css.employeeDialogTitle}>
            {i18n.t('admin.stations.title.activityDescriptions')}
          </DialogTitle>
          <DialogContent className={css.employeeDialogContent}>{employeeAdditionalInfoDialogContent}</DialogContent>
          <DialogActions className={css.employeeDialogActions}>
            <Button type='button' onClick={this.closeDialog}>
              {i18n.t('buttons.cancel')}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    )
  }
}

export default EmployeeAdditionalInfo
